import { render, staticRenderFns } from "./StorageList.vue?vue&type=template&id=4fde15a9&scoped=true"
import script from "./StorageList.vue?vue&type=script&lang=js"
export * from "./StorageList.vue?vue&type=script&lang=js"
import style0 from "./StorageList.vue?vue&type=style&index=0&id=4fde15a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde15a9",
  null
  
)

export default component.exports